import { Injectable } from '@angular/core';
import { asyncScheduler, BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, observeOn } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private activeRequests = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  // Emit on the async scheduler to avoid NG0100 when `show()` is triggered
  // during the initial change-detection cycle (e.g., initial navigation / interceptors).
  readonly loading$: Observable<boolean> = this.loadingSubject.asObservable().pipe(
    distinctUntilChanged(),
    observeOn(asyncScheduler),
  );

  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this.loadingSubject.next(false);
    }
  }

  reset(): void {
    this.activeRequests = 0;
    this.loadingSubject.next(false);
  }
}
